import { combineReducers } from 'redux'

import data from './data/slice'

const statisticsReducer = combineReducers({
  data,
})

export default statisticsReducer
